import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject, shareReplay } from 'rxjs';
declare let google: any;

@Injectable({
  providedIn: 'root',
})
export class ResultsService {
  private readonly BASE_URL = environment.END_URL;
  private variableSubject = new BehaviorSubject<any>(null);
  private locationName$: any = null;
  private latitude: any = null;
  private longitude: any = null;

  getIpAddress$: Observable<any> | undefined;

  searchSubject$ = new Subject<any>();
  getSearchList$: Observable<any> | undefined;

  searchedString: string = '';

  variable$ = this.variableSubject.asObservable();

  options = {
    enableHighAccuracy: false,
    timeout: 5000,
    maximumAge: 1800000,
  };

  constructor(private http: HttpClient) {}

  setVariable(newValue: any) {
    this.variableSubject.next(newValue);
  }

  // getResultsSearch(data: any) {
  //   return this.http.post(`${this.BASE_URL}/api/result/search`, data);
  // }

  getResultsSearch(data: any) {
    return this.http
      .post(`${this.BASE_URL}/api/result/search`, data)
      .pipe(shareReplay(1));
  }

  // public getGlobalResultsSearch(data: any) {
  //   if (!this.getSearchList$) {
  //     this.getSearchList$ = this.getResultsSearch(data);
  //   }
  //   return this.getSearchList$;
  // }

  // clearSearchResult() {
  //   this.getSearchList$ = undefined;
  // }

  getResultByID(id: any) {
    return this.http.get(`${this.BASE_URL}/api/result/result-id/${id}`);
  }

  auditDetails(data: any) {
    return this.http.post(`${this.BASE_URL}/api/audittrail/website`, data);
  }

  // rxjs subject added for detect search params changes
  updateSearchParams(data: any) {
    this.searchSubject$.next(data);
  }

  storeData(val: any) {
    this.searchedString = val;
  }

  getData() {
    return this.searchedString;
  }

  clearData() {
    this.searchedString = '';
  }

  isResultLoading(value: boolean) {
    this.setVariable(value);
  }

  getIpAddress() {
    return this.http
      .get('https://api.ipify.org/?format=json')
      .pipe(shareReplay(1));
  }

  public getPublicIp() {
    if (!this.getIpAddress$) {
      this.getIpAddress$ = this.getIpAddress();
    }
    return this.getIpAddress$;
  }

  async getGeoLocation(): Promise<boolean> {
    if (this.locationName$) {
      return true;
    }
    if ('geolocation' in navigator) {
      try {
        const position = await this.getCurrentPosition();
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        return true;
      } catch (error) {
        console.error('Error getting geolocation:', error);
        return false;
      }
    } else {
      console.error('Geolocation is not available in this browser');
      return false;
    }
  }

  private getCurrentPosition(): Promise<GeolocationPosition> {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (position) => resolve(position),
        (error) => reject(error),
        this.options
      );
    });
  }

  async getAddress(): Promise<any> {
    if (this.locationName$) {
      return this.locationName$;
    }
    if (navigator.geolocation && this.latitude && this.longitude) {
      try {
        const locationName = await this.reverseGeocode();
        this.locationName$ = locationName;
        return locationName;
      } catch (error) {
        console.error('Error getting address:', error);
        return null;
      }
    } else {
      console.error(
        'Geolocation is not available or latitude/longitude are not set'
      );
      return null;
    }
  }

  private reverseGeocode(): Promise<string> {
    return new Promise((resolve, reject) => {
      const geocoder = new google.maps.Geocoder();
      const latlng = new google.maps.LatLng(this.latitude, this.longitude);
      geocoder.geocode({ location: latlng }, (results: any, status: any) => {
        if (status === google.maps.GeocoderStatus.OK) {
          const locationName = results[0].formatted_address
            .split(' ')
            .slice(-4)
            .join(' ');
          resolve(locationName);
        } else {
          reject(new Error('Geocoding failed with status: ' + status));
        }
      });
    });
  }

  getPdfdata(url: any) {
    return this.http.get(url, { responseType: 'blob' });
  }

  getPredictiveTexts(data: any) {
    return this.http.post(`${this.BASE_URL}/api/result/search-text`, data);
  }
}
